import { useEffect } from 'react';
import { UserManager } from 'oidc-client-ts';

/**
 * Silent renewal page — loaded inside an iframe by oidc-client-ts when the
 * access token is about to expire. We just hand the URL fragment back to the
 * library's helper, which posts it up to the parent frame.
 */
export function SilentCallback() {
  useEffect(() => {
    // The library reads its own stored settings to drive the post-message.
    // We don't need to construct a full UserManager — `signinSilentCallback`
    // is a static helper that resolves from the URL.
    new UserManager({
      authority: '',
      client_id: '',
      redirect_uri: '',
    })
      .signinSilentCallback()
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('[silent-callback] failed', err);
      });
  }, []);
  return null;
}
